import React, { Component, Fragment } from 'react';
import AjouterRecette from './AjouterRecette'
import AdminForm from './AdminForm'
import Login from './Login'
import { Redirect } from 'react-router-dom'
import firebase from 'firebase/app'
import 'firebase/auth'
import base, { firebaseApp } from '../base'


class Admin extends Component {
    state = {
        uid: null,
        chef: null,
        redirect: false
    }

    componentDidMount () {
        firebase.auth().onAuthStateChanged(user => {
            if(user){
                this.handleAuth({ user })
            }
        })
    }

    handleAuth = async authData => {
        const box = await base.fetch(`/user/${this.props.pseudo}`, { context: this })
        if(!box.chef){
            //ecrire data
            await base.post(`/user/${this.props.pseudo}/chef`, {
            data: authData.user.uid
            })
            await base.post(`/user/${this.props.pseudo}/name`, {
                data: this.props.pseudo
                })
            await base.post(`/user/${this.props.pseudo}/confirm`,{
            data: "0"
            })
            await base.post(`/user/${this.props.pseudo}/admin`,{
            data: "0"
            })
            await base.post(`/user/${this.props.pseudo}/id`,{
                data: Date.now()
            })
        }

        this.setState({
            uid:authData.user.uid,
            chef:box.chef || authData.user.uid
        })
    }
        
   
//connecter via firebase
    authenticate = () => {
        const authProvider = new firebase.auth.FacebookAuthProvider()
        firebaseApp
            .auth()
            //Acceptez vous de vous loguer avec FB(popup)
            //renvoi une promise
            .signInWithPopup(authProvider)
            .then(this.handleAuth)
    }

    logout = async () => {
        await firebase.auth().signOut()
        this.setState({ uid:null})
    } 

    setRedirect = () => {
        this.setState({
          redirect: true
        })
      }

    renderRedirect = () => {
        if (this.state.redirect) {
          return <Redirect push to={
            {
                pathname:  `/users/${this.props.pseudo}`,
                state: { chef: this.state.chef}
            }} />
        }
      }


    render() {
        const { recettes, ajouterRecette, majRecette, supprimerRecette, admin, confirm, id, chef } =
        {...this.props} 
        
        const logout = <button onClick={this.logout}>Deconnexion</button>

        //si l'utilisateur n'est pas connectré
        if(!this.state.uid){
            return <Login authenticate={this.authenticate}/>
        }

        if(this.state.uid !== this.state.chef){
            return(
                <div>
                 <p>Tu n'es pas le chef de cette boîte</p>
                 {logout}
                </div>
            )
        }
        if(confirm !== "1")
        {
            return(
                <h2 className='notFound'>En attente de validation</h2>
            )
        }
        return (
            <div className='cards'>
                <AjouterRecette 
                id={id}
                chef={chef}
                ajouterRecette={ajouterRecette}/>
                {
                    Object.keys(recettes)
                    .map(key => <AdminForm
                    key={key}
                    id={key} 
                    majRecette={majRecette}
                    supprimerRecette={supprimerRecette}
                    recettes={recettes}/>)
                }
                <footer>
                    {(admin === "1" || admin === "2" ) &&
                        <Fragment>
                        {this.renderRedirect()}
                        <button onClick={this.setRedirect}>Gestion utilisateurs</button>
                       </Fragment>
                    }
                    {logout}
                </footer>
            </div>

        );
    }
}

export default Admin;